/* Итог «Создать кавер» (docs/03-api.md §9.4: result.kind audio_set — два варианта, у каждого url, duration_ms, peaks): чистые функции без DOM.
   Варианты — файлы звука готового заказа по порядку (родной хвост: CoverOrderResult — assets с mime audio/*); волна и длина варианта —
   поля его файла, иначе строки result.items / result.data.items того же номера, иначе общие поля итога. Подпись — caption · sub. */
import type { SpeechOrder } from '../../api/speech';
import { record, rows, text } from '../studio/studio-content';

export interface CoverVariant {
  /** index файла итога (openResult) */
  index: number;
  name: string;
  durationMs: number | null;
  peaks: number[] | null;
  caption: string;
}

const ms = (value: unknown) => (typeof value === 'number' && Number.isFinite(value) && value > 0 ? Math.round(value) : null);
const peaksOf = (value: unknown) =>
  Array.isArray(value) && value.length > 1 && value.every(x => typeof x === 'number' && Number.isFinite(x)) ? (value as number[]).map(x => Math.max(0, Math.min(1, x))) : null;

/** Варианты готового заказа (не готов или итог недоступен — пусто) */
export function coverVariants(order: SpeechOrder | null | undefined): CoverVariant[] {
  if (order?.status !== 'done' || !order.result?.available) return [];
  const result = record(order.result);
  const items = rows(result.items).length ? rows(result.items) : rows(record(result.data).items);
  return order.result.assets
    .filter(asset => asset.mime.startsWith('audio/'))
    .map((asset, i) => {
      const own = record(asset);
      const item = items[i] ?? {};
      const single = i === 0;
      return {
        index: asset.index,
        name: asset.file_name,
        durationMs: ms(own.duration_ms) ?? ms(item.duration_ms) ?? (single ? ms(result.duration_ms) : null),
        peaks: peaksOf(own.peaks) ?? peaksOf(item.peaks) ?? (single ? peaksOf(result.peaks) : null),
        caption: [text(item.caption), text(item.sub)].filter(Boolean).join(' · '),
      };
    });
}

/** Пики n штук из любого числа (линейно), как resample шаблона; нет пиков — ровная волна */
export function resample(p: readonly number[] | null | undefined, n: number): number[] {
  if (!p || !p.length) return Array<number>(n).fill(0.2);
  if (p.length === n) return p.slice();
  if (p.length === 1) return Array<number>(n).fill(p[0]);
  return Array.from({ length: n }, (_, i) => {
    const x = (i * (p.length - 1)) / (n - 1),
      a = Math.floor(x),
      b = Math.min(p.length - 1, a + 1),
      t = x - a;
    return p[a] * (1 - t) + p[b] * t;
  });
}
